export const priceFormater = (price) => {
    switch (price.toString().length) {
        case 9:
            return price = price.toString().slice(0, 3) + ' M';
        case 8:
            return price = price.toString().slice(0, 2) + ' M';
        case 7:
            return price = price.toString().slice(0, 1) + ' M';
        case 6:
            return price = price.toString().slice(0, 3) + ' K';
        case 5:
            return price = price.toString().slice(0, 2) + ' K';
        case 4:
            return price = price.toString().slice(0, 1) + ' K';
        case 3:
            return price = price.toString();
        default:
            return price = price.toString();
    }
};